import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Subject, mergeMap, Subscription } from 'rxjs';
import { LoggerService } from '@lib.core/logger/logger.service';
import { NavigationInteractor } from '@lib.core/navigator/navigation.interactor';
import { ClientIdStorageService } from '@public/src/app/store/store-access/client-id-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ClientIdQParamInteractor {
  private readonly clientIdParam = 'clientId';
  private readonly subscriptions: Subscription[] = [];
  private logger: LoggerService;
  private readonly qParamReaderTrigger$$ = new Subject<void>();
  private readonly qParamReaderTrigger$ = this.qParamReaderTrigger$$.asObservable();

  constructor(
    private activatedRoute: ActivatedRoute,
    private clientIdService: ClientIdStorageService,
    private navigator: NavigationInteractor) {
    this.logger = LoggerService.getLoggerService();
    this.subscribeToQParamReader();
    this.subscribeToQParamWriter();
  }

  readClientIdFromQParam() {
    this.qParamReaderTrigger$$.next();
  }

  destroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private subscribeToQParamReader() {
    this.subscriptions.push(
      this.qParamReaderTrigger$.pipe(
        mergeMap(() => this.activatedRoute.queryParams),
        map(qp => qp[this.clientIdParam] ?? null)
      )
      .subscribe({
        next:  (clientId: string) => {
          this.clientIdService.setClientId(clientId);
        },
        error: (error) => this.logger.error(error),
      })
    );
  }

  private subscribeToQParamWriter() {
    this.clientIdService.getClientId()
      .subscribe({
        next: (clientId: string) => {
          this.navigator.queueNavigation(
            [],
            {
              relativeTo: this.activatedRoute,
              queryParams: { clientId },
              queryParamsHandling: 'merge',
              preserveFragment: true
            }
          );
        },
        error: (error) => this.logger.error(error),
    });
  }
}
